<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Permisos</h3>
    </template>

    <permission-form
      ref="form"
      :key="formKey"
      :permission="permission"
      @create="create"
      @update="update"
      @cancel="reset"
    >
    </permission-form>

    <el-table
      :data="tableData"
      header-row-class-name="thead-light"
      class="table-responsive table"
      row-key="id"
      @sort-change="sortChange"
    >
      <!-- :data="tableData" header-row-class-name="thead-light"> -->
      <el-table-column label="Distribuidor" min-width="200px">
        <template #default="{ row }">
          <small>
            {{ row.shareable.name }}
          </small>
        </template>
      </el-table-column>

      <el-table-column label="Lectura" max-width="80px" align="left" prop="field.producer">
        <template #default="{ row }">
          <i class="fas" :class="{ 'fa-check text-success': row.read, 'fa-times text-danger': !row.read }"></i>
        </template>
      </el-table-column>

      <el-table-column label="Escritura" max-width="80px" align="left" prop="field.producer">
        <template #default="{ row }">
          <i class="fas" :class="{ 'fa-check text-success': row.write, 'fa-times text-danger': !row.write }"></i>
        </template>
      </el-table-column>

      <el-table-column align="right" label="" min-width="140px">
        <template slot-scope="{ row }">
          <div class="d-flex">
            <button
              v-if="$can('update', 'plot_permissions')"
              class="btn base-button btn-outline-primary btn-sm float-left"
              @click="edit(row)"
            >
              <i class="fas fa-pen"></i>
            </button>
            <button
              v-if="$can('destroy', 'plot_permissions')"
              class="btn base-button btn-outline-danger btn-sm float-left"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </card>
</template>

<script>
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';
import PaginationMixin from '../../../mixins/paginationMixin';
import { Table, TableColumn } from 'element-ui';
import PermissionForm from '../Forms/PermissionForm';

export default {
  name: 'PlotPermissionsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PermissionForm,
  },

  mixins: [PaginationMixin, DeleteRowFromTableMixin],
  props: {
    plot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tableData: [],
      formKey: 0,
      permission: {
        id: null,
        plotId: null,
        shareableId: null,
        shareableType: 'distributors',
        read: false,
        write: false,
      },
    };
  },

  created() {
    this.fetchTableData();

    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará el permiso';
    this.alertSuccessSettings.message = 'El permiso ha sido eliminado';
    this.resourceName = 'plot_permissions';
  },

  methods: {
    fetchTableData() {
      this.service()
        .get()
        .then((res) => res.data.data)
        .then(({ permissions }) => (this.tableData = permissions));
    },

    edit(row) {
      this.formKey++;
      this.permission = { ...row, ...{ read: Boolean(row.read), write: Boolean(row.write) } };
    },

    create(formData) {
      return this.service()
        .create(formData)
        .then((res) => {
          this.tableData.push(res.data.data);
          this.reset();
          this.$success('Permiso creado con éxito', 'Listo!');
        })
        .catch((err) => {
          if (Array.isArray(err)) {
            this.$error(err.join(', '));
          }
        });
    },

    update(formData) {
      return this.service()
        .update(formData.id, formData)
        .then((res) => {
          const permissions = this.tableData.slice();
          permissions[permissions.findIndex((i) => formData.id === i.id)] = res.data.data;

          this.tableData = [];
          this.tableData = permissions;

          this.reset();
          this.$success('Permiso actualizado con éxito', 'Listo!');
        })
        .catch((err) => {
          if (Array.isArray(err)) {
            this.$error(err.join(', '));
          }
        });
    },

    reset() {
      this.permission = {
        id: null,
        plotId: null,
        shareableId: null,
        shareableType: 'distributors',
        read: false,
        write: false,
      };
      this.$refs.form.clean();
    },

    service() {
      return this.$services.resource('plot_permissions').setPlot(this.plot.id);
    },
  },
};
</script>

<style scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: keep-all;
}
</style>
